// El OData `FormasPago` de BC no expone ningún campo que clasifique la forma de
// pago como efectivo o tarjeta, así que `Tipo_Pago` caía siempre a "Efectivo".
// Solución de emergencia hasta que BC exponga el campo real: se deriva del `Code`.
// `TRANS_BANC` (transferencia bancaria) se trata como efectivo por pedido de
// negocio -- cuenta dentro del efectivo en los totales del cierre de caja.
// El resto de la app compara contra los strings exactos "Efectivo" / "Tarjeta".
const TIPO_PAGO_POR_CODE = {
	EFECTIVO: "Efectivo",
	TRANS_BANC: "Efectivo",
	TJCTO: "Tarjeta",
};

export const resolveTipoPagoDesdeCode = (code) => {
	const normalized = (code ?? "").toString().trim().toUpperCase();
	if (TIPO_PAGO_POR_CODE[normalized]) return TIPO_PAGO_POR_CODE[normalized];
	// Cualquier otro código de tarjeta que no esté en el mapa: mejor tarjeta que
	// contar dinero de tarjeta como efectivo en el arqueo.
	if (/TARJ|TJ/.test(normalized)) return "Tarjeta";
	return "Efectivo";
};
